import React, { Component } from 'react';
import Magnifier from 'react-magnifier';
import './VehicleFuelReceipts.css'

interface VehicleFuelReceiptsProps {
    details: any
    receipts: Array<any>
}

type VehicleFuelReceiptsTypes = {
    receiptIndex: number
    zoomFactor: number
    canZoom: boolean
}

class VehicleFuelReceipts extends Component<VehicleFuelReceiptsProps, VehicleFuelReceiptsTypes>{

    constructor(props: any) {
        super(props)
        this.state = {
            receiptIndex: 0,
            zoomFactor: .6,
            canZoom: false
        }
        this.handleMouseWheel = this.handleMouseWheel.bind(this)
    }

    componentDidMount() {
        document.addEventListener('wheel', this.handleMouseWheel)
    }

    componentWillUnmount() {
        document.removeEventListener('wheel', this.handleMouseWheel);
    }

    handleMouseWheel = (event: any) => {
        if (this.state.canZoom) {
            if (event.deltaY < 0 && this.state.zoomFactor < 3) {
                this.setState({ zoomFactor: this.state.zoomFactor + .2 })
            }
            if (event.deltaY > 0 && this.state.zoomFactor >= .8) {
                this.setState({ zoomFactor: this.state.zoomFactor - .2 })
            }
        }
    }

    toggleZoom = (args: string) => {
        if (args === "off") {
            this.setState({ canZoom: false })
        } else {
            this.setState({ canZoom: true })
        }
    }

    panImage = (direction: string) => {
        if (direction === "+") {
            if (this.state.receiptIndex < this.props.receipts.length - 1) {
                this.setState({ receiptIndex: this.state.receiptIndex + 1 })
            }
        } else {
            if (this.state.receiptIndex > 0) {
                this.setState({ receiptIndex: this.state.receiptIndex - 1 })
            }
        }
    }

    render() {

        return (
            <div className="VehicleFuelReceipts">
                {this.props.receipts.length === 0 && <div className="NoVehicleFuelReceiptsWrapper">
                    <p>No Fuel Receipts</p>
                </div>}
                {this.props.receipts.length > 0 && <div className="VehicleFuelReceiptImageWrapper">
                    <div className="Fuel-Receipts-Header">
                        <p id="fuel-receipt-name">{this.props.receipts[this.state.receiptIndex].attachedByName}</p>
                        <p id="fuel-receipt-date">{this.props.receipts[this.state.receiptIndex].createdDate}</p>
                    </div>
                    <div className="Fuel-Receipt-Wrapper" key={"fuel-receipt-wrapper-" + this.state.receiptIndex}>
                        <div id="vehicle-fuel-reciepts-pan-left">
                            <span className="material-icons" onClick={() => this.panImage("-")}>keyboard_arrow_left</span>
                        </div>
                        <div id="fuel-receipt-img-wrapper" onMouseEnter={() => this.toggleZoom("on")} onMouseLeave={() => this.toggleZoom("off")}>
                            {/*!!r-18-bk*/}
                            {/*@ts-ignore*/}
                            <Magnifier src={this.props.receipts[this.state.receiptIndex].imageFullUrl} height={'100%'} mgWidth={200} mgHeight={200} zoomFactor={this.state.zoomFactor} mgShowOverflow={false} />
                        </div>
                        <div id="vehicle-fuel-reciepts-pan-right">
                            <span className="material-icons" onClick={() => this.panImage("+")}>keyboard_arrow_right</span>
                        </div>
                    </div>
                </div>}
            </div>
        )
    }
}

export default VehicleFuelReceipts